export default () => {
    let downloadForms = document.querySelectorAll('.js-download');

    if (!downloadForms.length)
        return;

    function isChecked(input) {
        return input.checked;
    }

    function isAnythingChecked(elements) {
        let isItChecked = false;

        for (let i = 0; i < elements.length; i++) {
            let currentEl = elements[i];
            if (isChecked(currentEl)) {
                isItChecked = true;
                break;
            }
        }

        return isItChecked;
    }

    downloadForms.forEach(function (item) {
        let inputs = item.querySelectorAll('input[type=checkbox]');
        let submit = item.querySelector('#js-download-submit');

        submit.disabled = !isAnythingChecked(inputs);

        [].forEach.call(inputs, function (input) {
            input.addEventListener('change', function () {
                submit.disabled = !isAnythingChecked(inputs);
            });
        });
    });
}